import * as React from "react";
import { Contents } from "../../Resoures/Contents";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { Urls } from "../../Urls";
import { SideMenu } from "../../../../Wrap/Constants/Enums/Menu/SideMenu";
import { CustomNavigationMenu } from "./CustomNavigationMenu";
import { isDLU } from "../../Resoures/DashboardContents";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { getQueryParameters } from "../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ContextStore } from "../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../Wrap/Constants/Enums/ContextType";
import { IActionMenuParamsModel } from "./IParameterModel";
import { getParams } from "../../../DLU/DLUHelper";
import CoachMarker from "../../../Shared/CoachMarkers/CoachMarker";
import { isAdminSpecificPage } from "../../../Admin/Dashboard/AdminDashboard";

interface ISecuredCustomNavigationProps {}

interface ISecuredCustomNavigationState {
    actionName?: string;
    overlayHTML?: JSX.Element;
}

// action menu
export class SecuredCustomNavigation extends BaseComponent<
    ISecuredCustomNavigationProps,
    ISecuredCustomNavigationState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            actionName: null,
            overlayHTML: null,
        };
    }

    private onClick(method: string) {
        const _Content = Contents;
        switch (method) {
            case _Content.Method_CloseMenu:
                this.setState({ overlayHTML: null });
                break;
            default:
                break;
        }
    }

    private onBtnClick() {
        let _overlayHTML: JSX.Element = null;
        const params = getQueryParameters();
        const key = Urls.getCurrentUrl();
        const headAccountHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Account);
        const subAccountHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.SubAccount);
        const customerId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        let urlParams: IActionMenuParamsModel = {
            headaccounthierarchyId: headAccountHierarchyId,
            subaccountHierarchyId: subAccountHierarchyId,
            levelHierarchyId: customerId,
            SideMenu: SideMenu.NotSpecified,
        };

        if (isAdminSpecificPage()) {
            urlParams.SideMenu = SideMenu.Admin;
        } else if (isDLU()) {
            urlParams = getParams();
        } else if (subAccountHierarchyId) {
            urlParams.SideMenu = SideMenu.NotSpecified;
        } else if (headAccountHierarchyId) {
            urlParams.SideMenu = SideMenu.Portfolio;
        } else {
            // left hand navigation
            switch (key) {
                case Contents.URLMap.dashboard:
                case Contents.URLMap.reports:
                    urlParams.SideMenu = SideMenu.Dashboard;
                    break;
                case Contents.URLMap.admin:
                    urlParams.SideMenu = SideMenu.Admin;
                    break;
                //TODO:  will remove after portfolio view done
                case Contents.URLMap.account:
                    urlParams.SideMenu = !CommonHelper.isNullOrEmpty(params["hierarchyId"])
                        ? SideMenu.Portfolio
                        : SideMenu.Dashboard;

                    urlParams.headaccounthierarchyId = params["hierarchyId"];
                    break;
                case Contents.URLMap.customer:
                    urlParams.SideMenu = customerId ? SideMenu.Account : SideMenu.Dashboard;
                    break;
                case Contents.URLMap.BusinessManagement:
                    urlParams.SideMenu = SideMenu.BusinessManagement;
                    break;
                case Contents.URLMap.toolsAndLiterature:
                    urlParams.SideMenu = SideMenu.ToolLiterature;
                    break;
                default:
                    break;
            }
        }

        _overlayHTML = <CustomNavigationMenu onClick={(method) => this.onClick(method)} urlParams={urlParams} />;

        this.setState({ overlayHTML: _overlayHTML });
    }

    public render(): JSX.Element {
        const { overlayHTML } = this.state;
        const isNotShow = Urls.getCurrentUrl() == Contents.URLMap.settings;
        return isNotShow ? null : (
            <div className="custom-navigation">
                <CoachMarker coachMarkerKey="custom-navigation" />
                <button className="custom-navigation-trigger" onClick={() => this.onBtnClick()}>
                    <span className="cnt-icon" aria-hidden={true} />
                    <span className="sr-only">Enter custom navigation</span>
                    <span className="cnt-label">Menu</span>
                </button>
                {overlayHTML !== null ? overlayHTML : null}
            </div>
        );
    }
}
